import AxiosDefault from "services/AxiosDefault";

export const GetFaqsAPI = async (params = {}) => {
  const response = await AxiosDefault({
    method: "GET",
    url: `/faq/get`,
    params,
  });
  return response;
};

export const GetFaqsByPlaceAPI = async (placeId) => {
  const response = await AxiosDefault({
    method: "GET",
    url: `/faq/getByPlace/${placeId}`,
  });
  return response;
};

export const CreateFaqAPI = async (data) => {
  const response = await AxiosDefault({
    method: "POST",
    url: `/faq/create`,
    data,
  });
  return response;
};

export const UpdateFaqAPI = async (faqId, data) => {
  const response = await AxiosDefault({
    method: "PUT",
    url: `/faq/update/${faqId}`,
    data,
  });
  return response;
};

export const DeleteFaqAPI = async (faqId) => {
  const response = await AxiosDefault({
    method: "PATCH",
    url: `/faq/delete`,
    data: { faqId },
  });
  return response;
};

export const AssignFaqPlacesAPI = async (faqId, placeIds) => {
  const response = await AxiosDefault({
    method: "PATCH",
    url: `/faq/assignPlaces`,
    data: { faqId, placeIds },
  });
  return response;
};

export const ReorderFaqsAPI = async (items, placeId) => {
  const response = await AxiosDefault({
    method: "PATCH",
    url: `/faq/reorder`,
    data: placeId ? { items, placeId } : { items },
  });
  return response;
};
